export default "__VITE_ASSET__DmOQAcrI__"